import React, { useState } from 'react';

import { Icon } from '@rbilabs/universal-components';

import { ILocaleStringFragment } from 'generated/sanity-graphql';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import {
  Action,
  Container,
  Content,
  PaymentDetails,
  PaymentMethod,
  StyledToggle,
  Title,
  Wrapper,
} from './loyalty-payment-method-widget.styled';

interface LoyaltyPaymentMethodWidget {
  title: ILocaleStringFragment;
}

const LoyaltyPaymentMethodWidget = ({ title }: LoyaltyPaymentMethodWidget) => {
  const enableMyCodePaymentMethod = useFlag(LaunchDarklyFlag.ENABLE_MY_CODE_PAYMENT_METHOD);
  const [toggle, setToggle] = useState<boolean>(false);

  const toggleUpdate = () => setToggle(!toggle);

  if (!enableMyCodePaymentMethod) {
    return null;
  }

  return (
    <Wrapper data-testid="loyalty-payment-method-widget">
      <Container>
        <Content>
          <Title>{title?.locale}</Title>
          <PaymentMethod>
            <Icon variant="visa" width="48px" aria-hidden mr="$3" />
            <PaymentDetails>1354</PaymentDetails>
          </PaymentMethod>
        </Content>
        <Action>
          <StyledToggle
            disabled={false}
            newUI={false}
            data-testid="payment-method-widget-action"
            onChange={toggleUpdate}
          />
        </Action>
      </Container>
    </Wrapper>
  );
};

export default LoyaltyPaymentMethodWidget;
